import { render, staticRenderFns } from "./AtendimentoPPT.vue?vue&type=template&id=1e53c24c&scoped=true"
import script from "./AtendimentoPPT.vue?vue&type=script&lang=js"
export * from "./AtendimentoPPT.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoPPT.vue?vue&type=style&index=0&id=1e53c24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e53c24c",
  null
  
)

export default component.exports